// Mensajes que se copian al compartir el acceso a la app de Foresta.
// IMPORTANTE: usar siempre el dominio de producción, NO el preview.

export const ACTIVATION_URL = "https://app.forestamaipu.com/activar";

// Mensaje que comparte el MASTER con sus AUTORIZADOS.
export const ACTIVATION_MESSAGE = `Hola! 👋

Te comparto el acceso a la app de Foresta:

🔗 ${ACTIVATION_URL}

Desde ahí vas a poder crear tu contraseña y usar la app para reservas, visitas, avisos e incidencias.

📲 Para dejarla instalada como app en el celular:

✅ Android:
Abrilo con Chrome, tocá los 3 puntitos y elegí "Agregar a pantalla principal" o "Instalar app".

✅ iPhone:
Abrilo con Safari, tocá Compartir y elegí "Agregar a pantalla de inicio".

Así te queda el ícono de Foresta en el celular y podés entrar como una app más.`;

// Mensaje que comparte RECEPCIÓN / OPERACIONES con un nuevo MASTER de unidad.
export const ACTIVATION_MESSAGE_MASTER = `Hola! 👋

Te compartimos el acceso a la app de Foresta:

🔗 ${ACTIVATION_URL}

Desde ahí vas a poder activar tu cuenta como responsable de tu unidad, crear tu contraseña y empezar a usar la app para:

📅 Reservar salas
👥 Cargar visitas
🛠️ Reportar incidencias
📦 Recibir avisos de correo y paquetería
🔔 Recibir notificaciones del edificio

📲 Para dejarla instalada como app en el celular:

✅ Android:
Abrilo con Chrome, tocá los 3 puntitos y elegí "Agregar a pantalla principal" o "Instalar app".

✅ iPhone:
Abrilo con Safari, tocá Compartir y elegí "Agregar a pantalla de inicio".

Así te queda el ícono de Foresta en el celular y podés entrar como una app más.`;
